module.exports = __webpack_public_path__ + "static/image/service/connect.ver2_0_2.jpg?1beb6564";